<template>
  <div class="rescue-order-price-wrap">
    <div class="price-info">
      <div class="pay-title">您需支付</div>
      <div class="price"><span>¥</span>{{ needPayAmount }}</div>
      <!-- <div v-if="isTransferCar && hasDestAddress" class="pay-info">本次{{ productName }}总里程为{{ distance }}公里，实际拖车总里程若超出{{ distance }}公里，超出部分为8元/公里，超出部分请直接与到现场作业人员结算</div> -->
      <!-- <div v-else-if="isTransferCar" class="pay-info">本次{{ productName }}服务默认为50公里以内，超出部分为8元/公里，超出部分请直接与到场作业人员结算</div> -->
      <!-- <div v-else class="pay-info">费用不含配件更换费用、中大型困境救援设备费</div> -->
      <div
        v-if="isTransferCar"
        class="pay-info"
      >{{ msg }}</div>
    </div>
    <div class="pay-way-wrap">
      <div
        v-if="isShowCancelFeeTips"
        class="cancel-fee-tips"
      >
        <div>取消收费说明:</div>
        <div>1、下单后超过10分钟取消，将收取基础费用的50%作为师傅的空驶费;</div>
        <div>2、师傅到达现场后，取消不退费。</div>
      </div>
      <div class="pay-way">
        <div class="pay-way-head">支付方式</div>
        <div class="way-list">
          <div
            class="way-item"
            @click="selectPayWay('wx')"
          >
            <img
              src="@/assets/img/wx-logo.png"
              class="logo"
            >微信
            <van-checkbox
              v-model="wxChecked"
              icon-size="24px"
              class="check-item"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="rule-wrap">
      <van-popover
        v-model="showPopover"
        theme="dark"
        placement="bottom-start"
      >
        <template>
          <div class="popup-msg">请阅读并勾选后再继续支付</div>
        </template>
      </van-popover>
      <van-checkbox
        v-model="ruleReaded"
        icon-size="16px"
      >我已阅读并同意</van-checkbox>

      <div
        class="link"
        @click="viewAgreement"
      >《中保车服道路救援服务条款》</div>
    </div>

    <div class="bottom-wrap">
      <div class="phone-wrap">
        24小时客服热线：<a
          class="link"
          href="tel://4000026862"
        >400-002-6862</a>
      </div>
      <div class="btn-wrap">
        <div
          class="btn"
          :class="{ disabled: disabled }"
          @click="toSubmit"
        >立即支付</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  rescueDetail,
  rescuePayPre,
  rescuePayCheck,
  rescueOrderCurrentData
} from '@/common/api.js';
import { PRODUCT_CODE_TYPE } from '@/common/product-config';
export default {
  data() {
    return {
      wxChecked: false,
      ruleReaded: false,
      showPopover: false,
      productCategoryType: '',

      prepayId: '', // 预支付id
      checkPayCount: 3, // 是否支付最多检查次数
      checkPayTime: 3000, // 每次检查是否支付中间的间隔
      detail: null,
      orderNo: '',
      msg: '',
      needPayAmount: '0',
      disabled: true,
      distance: ''
    };
  },
  computed: {
    hasDestAddress: function() {
      return this.detail.destAddress;
    },
    isTransferCar: function() {
      // 需要拖车的
      return ['FL10000002'].includes(this.productCategoryType);
    },
    isShowCancelFeeTips: function() {
      const {
        roadRescueType,
        distressRescueType,
        accidentRescueType
      } = PRODUCT_CODE_TYPE;
      return [
        ...roadRescueType,
        ...distressRescueType,
        ...accidentRescueType
      ].includes(this.productCategoryType);
    }
  },
  beforeCreate() {
    document.querySelector('body').classList.add('gray');
  },
  beforeDestroy() {
    document.querySelector('body').classList.remove('gray');
  },
  async mounted() {
    // TODO:
    // this.$route.query.orderKey = "bf8f990b19c346cd96dec41f4622e227";
    if (this.$route.query.orderKey) {
      this.orderKey = this.$route.query.orderKey;
    } else {
      this.$toast('缺少 orderKey');
      return;
    }
    this.initQuery();
    await this.orderCurrentData();
    await this.rescueDetail();
  },
  methods: {
    selectPayWay(way) {
      const attr = `${way}Checked`;
      this[attr] = !this[attr];
    },
    async rescueDetail() {
      try {
        const rs = await rescueDetail({
          orderKey: this.orderKey
        });
        console.log(rs);
        if (rs) {
          this.detail = rs;
          this.needPayAmount = rs.needPayAmount ? rs.needPayAmount.toString() : '0';
          this.productCategoryType = rs.productCategoryType;
          if (!(this.needPayAmount > 0)) {
            this.$toast('暂无待支付金额');
            return;
          }
          this.disabled = false;
          if (this.detail.productCategoryType == 'FL10000002' && this.needPayAmount > 0) {
            let msg = '';
            if (this.detail.destAddress) {
              // 2020.7.28 念镁要改的
              const totalMileage = this.detail.productParameter;
              msg = `本次${this.detail.productName}总里程为${this.distance}公里，如实际总里程大于${totalMileage}公里，超出部分为8元/公里，超出部分请直接与到现场作业人员结算`;
            } else {
              let mileage = 50;
              if (this.detail.orderSource === '05' || this.detail.orderSource === '06') {
                mileage = this.detail.productParameter;
              }
              msg = `由于您没有选择终点地址，本次拖车默认为${mileage}公里以内拖车，超出部分为8元/公里，请直接与到现场作业人员结算`;
            }
            this.msg = msg;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async orderCurrentData() {
      try {
        const rs = await rescueOrderCurrentData({
          orderKey: this.orderKey
        });
        if (rs) {
          this.distance = rs.distance ? rs.distance.toString() : '0';
        }
      } catch (error) {
        console.log(error);
      }
    },
    async toSubmit() {
      if (this.disabled) {
        return;
      }
      if (!this.ruleReaded) {
        this.showPopover = true;
        return;
      }
      if (this.needPayAmount != 0 && !this.wxChecked) {
        this.$toast('请选择支付方式');
        return;
      }

      this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      try {
        const rs = await rescuePayPre({
          orderKey: this.orderKey
        });
        console.log(rs);
        if (rs && rs.mwebUrl) {
          this.prepayId = rs.prepayId;
          const redirectUrl = encodeURIComponent(
            `${window.location.href}&isCallBack=1&payWay=wx`
          );
          window.location.href = `${rs.mwebUrl}&&redirect_url=${redirectUrl}`;
        } else if (this.needPayAmount == 0) {
          // 无费用，直接去订单成功
          this.toOrderResult();
        }
      } catch (error) {
        console.log(error);
      }
      this.$toast.clear();
    },
    async initQuery() {
      // 支付回调过来的
      if (this.$route.query.isCallBack) {
        // showCheckDialog
        this.ruleReaded = true;
        this.showConfirmDialog();
      }
      // 支付类型
      if (this.$route.query.payWay) {
        this[`${this.$route.query.payWay}Checked`] = true;
      }
    },
    async showConfirmDialog() {
      this.$toast.loading({
        message: '支付结果检查中...',
        forbidClick: true,
        duration: 0
      });
      this.checkPay();
    },
    async checkPay() {
      const payRs = await rescuePayCheck({
        orderKey: this.orderKey
      });
      console.log(payRs);
      if (payRs && payRs.orderStatus !== 'PAID_WAIT') {
        this.$toast.clear();
        this.toOrderResult();
      } else {
        if (this.checkPayCount <= 0) {
          this.$toast('未检查到支付信息');
        } else {
          this.checkPayCount -= 1;
          setTimeout(() => {
            this.checkPay(true);
          }, this.checkPayTime);
        }
      }
    },
    viewAgreement() {
      this.$router.push('rescueAgreement');
    },
    toOrderResult() {
      this.$router.push('orderResult');
    }
  }
};
</script>

<style lang="scss">
body {
  &.gray {
    background-color: #f7f7f7;
  }
}
.rescue-order-price-wrap {
  line-height: 1.4;

  .link {
    color: #3399ff;
  }

  .price-info {
    background-color: #fff;
    text-align: center;
    padding: 28px 28px 32px;
    font-size: 14px;
    color: #969696;

    .pay-title {
      font-size: 20px;
    }
    .price {
      color: #3399ff;
      font-size: 48px;

      > span {
        font-size: 24px;
      }
    }
    .pay-info {
      word-break: break-all;
    }
  }
  .pay-way-wrap {
    padding: 13px 12px;

    .cancel-fee-tips {
      margin-bottom: 12px;
      padding: 0 4px;
      color: #f32222;
      font-size: 14px;
      font-weight: 700;
      line-height: 22px;
    }
  }
  .pay-way {
    background-color: #fff;
    padding: 0 16px;
    border-radius: 10px;

    .pay-way-head {
      padding-left: 10px;
      position: relative;
      height: 36px;
      line-height: 36px;
      font-size: 16px;
      // font-weight: bold;
      color: #383838;
      border-bottom: 1px solid #e6e6e6;

      &::after {
        content: "";
        width: 4px;
        height: 15px;
        background-image: linear-gradient(180deg, #62c9ff 0%, #3399ff 100%);
        position: absolute;
        left: 0px;
        top: 50%;
        margin-top: -7px;
        border-radius: 2px;
      }
    }
    .way-list {
      padding-top: 4px;
      font-size: 16px;
      color: #383838;
      .way-item {
        line-height: 34px;
        position: relative;
        display: flex;
        padding: 16px 0 16px 4px;

        .check-item {
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -12px;
        }
      }
    }
    .logo {
      width: 34px;
      height: 34px;
      display: block;
      margin-right: 16px;
    }
  }
  .rule-wrap {
    padding-left: 32px;
    font-size: 12px;
    line-height: 20px;
    color: #969696;
    display: flex;

    .van-checkbox__label {
      color: #969696;
      font-size: 12px;
    }
  }
  .bottom-wrap {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    text-align: center;

    .phone-wrap {
      font-size: 12px;
      color: #c8c8c8;
      padding-bottom: 12px;

      .link {
        text-decoration: none;
        color: #8ec8ff;
      }
    }
    .btn-wrap {
      background-color: #fff;
      border-top: 1px solid #e6e6e6;
      padding: 8px 12px;

      .btn {
        color: #fff;
        background: #3399ff;
        width: 100%;
        height: 45px;
        line-height: 45px;
        text-align: center;
        border-radius: 23px;
        font-size: 16px;
      }
      .disabled {
        background: #b3d9ff;
      }
    }
  }
}
.popup-msg {
  font-size: 16px;
  color: #ffffff;
  padding: 9px 15px;
}
.van-popover__content {
  border-radius: 4px;
}
</style>
